import React from "react"
import { EVENT_TYPE_UPLOAD, EVENT_TYPE_DOWNLOAD } from "./TimelineEvent"
import {
  TimelineEventDetails,
  TimelineEventTitle,
} from "./styled/TimelineEventDetails"
import UploadDetails from "./UploadDetails"
import DownloadDetails from "./DownloadDetails"
import { useTimelineEventData } from "../TimelineEventDataProvider"

const TransferDetails = () => {
  const { eventType, transferDetails } = useTimelineEventData()

  return (
    <TimelineEventDetails>
      {transferDetails && (
        <TimelineEventTitle>
          {eventType === EVENT_TYPE_UPLOAD && (
            <UploadDetails {...transferDetails} />
          )}
          {eventType === EVENT_TYPE_DOWNLOAD && (
            <DownloadDetails {...transferDetails} />
          )}
        </TimelineEventTitle>
      )}
    </TimelineEventDetails>
  )
}

export default TransferDetails
